'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepBadge } from '../pipeline-step-badge';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';

interface ITriagedStepProps {
  item: ICollectionPipelineStatusV3;
}

export function TriagedStep({ item }: ITriagedStepProps): JSX.Element {
  const triaged = item.steps.triaged ?? { done: 0, total: 0 };
  return (
    <PipelineStepCell
      badge={<PipelineStepBadge step={triaged} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="Triaged"
          description={`Clips reviewed in triage out of all servable clips. This is a clip-level count (one row per clip), so it equals the number shown in the mobile triage flow, not the challenge-level Cropped column. ${triaged.done}/${triaged.total} clips triaged.`}
          dataHref={`/sys/media?collectionId=${item.collectionId}`}
          dataLabel="Open clips"
        />
      )}
    />
  );
}
